import { Injectable } from '@angular/core';

import { ApiService, LogService, AppContext } from './../../../shared';
declare const moment;

@Injectable()
export class EmailSettingsService {
  timezones: Array<string> = [];
  userTimeZone: string = '';
  hourOfDay: number = 9;
  public mondayVar = false;
  public tuesdayVar = false;
  public wednesdayVar = false;
  public thursdayVar = false;
  public fridayVar = false;
  daysOfWeek: Array<number> = [];
  emailYourself: boolean = false;
  emailOthers: boolean = false;
  email: string = '';
  otherEmails = new Array<string>();
  public loading = false;
  public message: string = '';

  errorPresent: boolean = false;
  emailError: string = '';

  constructor(private api: ApiService, private logger: LogService, private app: AppContext) {
    this.init();
  }

  init() {
    try {
      this.userTimeZone = moment.tz.guess();
    } catch (ex) {
      this.userTimeZone = '';
    }

    this.api.getApiClient().then(client => this.callGetEmailDeliverySettings(client));
    this.api.getApiClient().then(client => this.callGetTimezones(client));
  }

  callGetEmailDeliverySettings(apigClient: any) {
    this.logger.log('email-settings.service', 'callGetEmailDeliverySettings', 'hello');
    let params = {};
    let body = {};
    let additionalParams = { headers: { 'Content-Type': 'application/json' } };
    try {
      apigClient.userEmailDeliverySettingsGet(params, body, additionalParams)
        .then((result) => {
          this.logger.log('email-settings.service', 'callGetEmailDeliverySettings result', result);
          this.formatSettings(result.data);
        }).catch((err) => {
          this.api.handleError(err);
          this.app.showMessage('Network Error', 'Please refresh the page to try again. If this issue persists, please contact our support');
        });
    } catch (ex) {
      this.app.showMessage('Network Error', 'Please refresh the page to try again. If this issue persists, please contact our support');
    }
  }

  formatSettings(data: any) {
    try {
      this.userTimeZone = data.userTimeZone.replace(/_/g, ' ');
      this.hourOfDay = data.hourOfDay;

      this.daysOfWeek = data.daysOfWeek instanceof Array ? data.daysOfWeek : data.daysOfWeek.values;
      this.mondayVar = this.daysOfWeek.indexOf(1) > -1 ? true : false;
      this.tuesdayVar = this.daysOfWeek.indexOf(2) > -1 ? true : false;
      this.wednesdayVar = this.daysOfWeek.indexOf(3) > -1 ? true : false;
      this.thursdayVar = this.daysOfWeek.indexOf(4) > -1 ? true : false;
      this.fridayVar = this.daysOfWeek.indexOf(5) > -1 ? true : false;

      this.emailYourself = data.emailSelf || false;

      if (data.otherEmails.length !== 0) {
        this.otherEmails = data.otherEmails;
        this.email = this.otherEmails.join(',');

        this.emailOthers = this.otherEmails.length !== 0;
      }
    } catch (ex) {
      this.logger.log('email-settings.service', 'formatSettings', 'no settings');
    }
  }

  callGetTimezones(apigClient: any) {
    this.logger.log('email-settings.service', 'callGetTimezones', 'hello');
    let params = {};
    let body = {};
    let additionalParams = { headers: { 'Content-Type': 'application/json' } };
    try {
      apigClient.timezonesGet(params, body, additionalParams)
        .then((result) => {
          this.logger.log('email-settings.service', 'timezones result', result);
          this.timezones = result.data;
        }).catch((err) => this.api.handleError(err));
    } catch (ex) {
    }
  }

  save() {

    this.errorPresent = false;
    this.emailError = '';
    this.message = '';

    if (!this.errorPresent) {
      let post;
      this.loading = true;

      post = {
        daysOfWeek: this.daysOfWeek,
        emailSelf: this.emailYourself,
        otherEmails: this.otherEmails,
        htmlEmails: true,
        emailFormat: 'html',
        hourOfDay: +this.hourOfDay,
        userTimeZone: this.userTimeZone
      };

      this.api.getApiClient().then(client => this.callUpdateDeliverySettings(client, post));
    }
  }

  callUpdateDeliverySettings(apigClient: any, post: any) {
    let params = {};
    let body = post;
    let additionalParams = { headers: { 'Content-Type': 'application/json' } };
    try {
      apigClient.userEmailDeliverySettingsPost(params, body, additionalParams)
        .then((result) => {
          this.logger.log('email-settings.service', 'callGetEmailDeliverySettings result', result);
          this.loading = false;
          this.message = 'Settings Saved';
        }).catch((err) => {
          this.api.handleError(err);
          this.loading = false;
          this.message = 'An error has occurred. Please try again later.';
          this.logger.log('email-settings.service', 'callUpdateDeliverySettings error', err);
          this.logger.log('email-settings.service', 'callUpdateDeliverySettings message', this.message);
        });
    } catch (ex) {
      this.loading = false;
      this.message = 'An error has occurred. Please try again later.';
    }
  }

  toggleEmailYourself() {
    this.emailYourself = !this.emailYourself;
  }

  toggleEmailOthers() {
    this.emailOthers = !this.emailOthers;
  }

  monday() {
    if (this.mondayVar) {
      let index = this.daysOfWeek.indexOf(1);
      this.daysOfWeek.splice(index, 1);
    } else {
      this.daysOfWeek.push(1);
    }
    this.mondayVar = !this.mondayVar;
  }

  tuesday() {
    if (this.tuesdayVar) {
      let index = this.daysOfWeek.indexOf(2);
      this.daysOfWeek.splice(index, 1);
    } else {
      this.daysOfWeek.push(2);
    }
    this.tuesdayVar = !this.tuesdayVar;
  }

  wednesday() {
    if (this.wednesdayVar) {
      let index = this.daysOfWeek.indexOf(3);
      this.daysOfWeek.splice(index, 1);
    } else {
      this.daysOfWeek.push(3);
    }
    this.wednesdayVar = !this.wednesdayVar;
  }

  thursday() {
    if (this.thursdayVar) {
      let index = this.daysOfWeek.indexOf(4);
      this.daysOfWeek.splice(index, 1);
    } else {
      this.daysOfWeek.push(4);
    }
    this.thursdayVar = !this.thursdayVar;
  }

  friday() {
    if (this.fridayVar) {
      let index = this.daysOfWeek.indexOf(5);
      this.daysOfWeek.splice(index, 1);
    } else {
      this.daysOfWeek.push(5);
    }
    this.fridayVar = !this.fridayVar;
  }

  updateEmails(emails: Array<string>) {
    this.otherEmails = emails;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/email-delivery/email-settings/email-settings.service.ts